<div *ngIf="meterExchangesImportResult">
  <b *ngIf="meterExchangesImportResult.preview">Ok count: {{meterExchangesImportResult.okCount}},   Error count: {{meterExchangesImportResult.errorCount}}</b>
  <clr-datagrid  class="meter-exchanges-table">
    <clr-dg-action-bar>
      <clr-button-group class="btn-sm btn-secondary">
        <clr-button (click)="export()">
          <clr-icon shape="export"></clr-icon> Export
        </clr-button>
      </clr-button-group>
    </clr-dg-action-bar>

    <clr-dg-column [clrDgField]="'oldMeterInfo'" [style.min-width.px]="200">
      <ng-container >Current meter</ng-container>
    </clr-dg-column>
    <clr-dg-column [clrDgField]="'newMeterInfo'" [style.min-width.px]="200">
      <ng-container >New meter</ng-container>
    </clr-dg-column>
    <clr-dg-column [clrDgField]="'exchangeDateString'" >
      <ng-container >Exchange date</ng-container>
    </clr-dg-column>
    <clr-dg-column [clrDgField]="'startValue'" >
      <ng-container >Start value</ng-container>
    </clr-dg-column>
    <clr-dg-column [clrDgField]="'endValue'" >
      <ng-container >End value</ng-container>
    </clr-dg-column>
    <clr-dg-column [clrDgField]="'ok'" >
      <ng-container >Status</ng-container>
    </clr-dg-column>
    <clr-dg-column [clrDgField]="'message'" [style.min-width.px]="200">
      <ng-container >Message</ng-container>
    </clr-dg-column>

    <clr-dg-row *clrDgItems="let item of meterExchangesImportResult.meterExchanges; let i = index" [clrDgItem]="item">
      <clr-dg-cell [style.min-width.px]="200">{{item.oldMeterInfo}}</clr-dg-cell>
      <clr-dg-cell [style.min-width.px]="200">{{item.newMeterInfo}}</clr-dg-cell>
      <clr-dg-cell>{{item.exchangeDateString}}</clr-dg-cell>
      <clr-dg-cell>{{item.startValue}} {{item.unit}}</clr-dg-cell>
      <clr-dg-cell *ngIf="item?.endValue >= 0">{{item.endValue}} {{item.unit}}</clr-dg-cell>
      <clr-dg-cell *ngIf="item?.endValue < 0">---</clr-dg-cell>
      <clr-dg-cell>{{item.ok ? 'Ok' : 'Error'}}</clr-dg-cell>
      <clr-dg-cell [style.min-width.px]="200">{{item.message}}</clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="20">
        <clr-dg-page-size i18n='@@customerevents_notifications' [clrPageSizeOptions]="[10,20,50,100]">
          Meter exchanges</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}} of {{pagination.totalItems}} meter exchanges
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</div>
